(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/hooks/pix-maltipset.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/hooks/pix-maltipset.js');
"use strict";


const ROW_PRICE_MALTIPS = 2.5;
const mapSizeToMsys = {
  9: 9,
  45: 10,
  165: 11 
};
const {
  helpers: {
    getNumberOfRows,
    SystemTypes
  }
} = svs.components.sport.quickplayModal;

async function queryMaltipsPixAsync(_ref) {
  let {
    drawNumber,
    systemCost,
    systemType
  } = _ref;
  const numberOfRows = getNumberOfRows(systemCost, ROW_PRICE_MALTIPS);
  let path = "/wager/1/maltipset/pix?flavour=SafeMaltipset&systemNumberMapping=".concat(mapSizeToMsys[numberOfRows], "&drawNumber=").concat(drawNumber);
  if (systemType === SystemTypes.SROW) {
    path = "/wager/1/maltipset/pix/singlerows?flavour=SafeMaltipset&drawNumber=".concat(drawNumber, "&numRows=").concat(systemCost);
  }

  const {
    response
  } = await svs.core.jupiter.callAsync({
    method: 'POST',
    path
  });
  if (response.error || !response.pixes && !response.pix) {
    var _response$error;
    throw new Error(((_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.message) || 'Failed to query wager-API');
  }
  return response.pixes || [response.pix];
}
const _convertMaltipsetBoardToSigns = (board, amountEvents) => {
  const signs = new Array(amountEvents).fill(false);
  board.forEach(eventNumber => {
    signs[eventNumber.value - 1] = true;
  });
  return signs;
};

function normaliseMaltipsPix(_ref2) {
  let {
    data = [],
    productId,
    drawNumber,
    systemCost,
    systemType,
    amountEvents
  } = _ref2;
  if (!Array.isArray(data) || data.length === 0) {
    throw new Error('Missing "pix.events" in response from wager-API.');
  }
  return {
    productId,
    drawNumber,
    systemCost,
    systemType,
    signsByEventForOutput: {
      maltipset: data.map(board => _convertMaltipsetBoardToSigns(board.outcomes, amountEvents))
    },
    wagerBoardData: {
      maltipset: data.map(board => ({
        boardData: board.outcomes.map(_ref3 => {
          let {
            value
          } = _ref3;
          return value;
        })
      })) 
    }
  };
}

setGlobal('svs.components.sport.quickplayModal.hooks', {
  queryMaltipsPixAsync,
  normaliseMaltipsPix
});

 })(window);